// project-specific additions to app bundle
import '../css/rosy.scss';
import 'leaflet/dist/leaflet.css';

import 'leaflet';
import 'proj4leaflet';

import 'spectrum-colorpicker2';